/* eslint-disable */
import BaseService from "./BaseService";

const API_IS_USER = `${process.env.VUE_APP_BACKEND_API}/User`;

class UserService extends BaseService
{
    static getUserProfile() {
        if (!this.hasSession())
            return Promise.reject();

        return window.axios.get(`${API_IS_USER}/Profile`);
    }

    static changePassword(oldPass, newPass) {
        if (!this.hasSession())
            return Promise.reject();
        let body = {
            "OldPassword": oldPass,
            "NewPassword": newPass
        };
        let url = `${API_IS_USER}/ChangePassword()`;
        return window.axios.post(url, body);
    }
}

export default UserService;
